import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { RadialBarCharts } from "../../../../Constant";
import Chart from "react-apexcharts";
import { CIRCLE_CHART } from "../../../../Data/Charts/ApexChart";

const RadialBarChart = () => {
  return (
    <Col sm="12" xl="6" className="box-col-6">
      <Card>
        <CommonCardHeader title={RadialBarCharts} />
        <CardBody>
          <div id="circlechart">
            <Chart options={CIRCLE_CHART} series={CIRCLE_CHART.series} type="radialBar" height={350} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default RadialBarChart;
